import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CompletedFormIcon, PendingFormIcon, SyncStatusIcon, StorageIcon} from '../Icons/svgIcons';
import {ICONS} from "../../constants/imageConstants";

const StatsCard = ({ title, value, change, icon, showArrow = true, path, onClick }) => {
  const navigate = useNavigate();

  const getIconComponent = (iconType) => {
    switch (iconType) {
      case 'completed': return <CompletedFormIcon className="w-5 h-5 icon-theme" />;
      case 'pending': return <PendingFormIcon className="w-5 h-5 icon-theme" />;
      case 'sync': return <SyncStatusIcon className="w-5 h-5 icon-theme" />;
      case 'storage': return <StorageIcon className="w-5 h-5 icon-theme" />;
      default: return null;
    }
  };

  const handleClick = () => {
    if (onClick) onClick();
    else if (path) navigate(path);
  };

  const isClickable = path || onClick;

  return (
    <div 
      className={`bg-white rounded-xl border-2 border-gray-200 p-4 flex flex-col justify-between h-full min-h-[100px] shadow-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5 ${
        isClickable ? 'cursor-pointer active:scale-[0.98]' : ''
      }`}
      onClick={handleClick} 
      role={isClickable ? 'button' : undefined} 
      tabIndex={isClickable ? 0 : undefined}
    >
      <div className="flex items-start justify-between mb-2">
        <div className="flex flex-col gap-1">
           <span className="text-gray-500 text-[11px] font-bold uppercase tracking-wider">{title}</span>
           <span className="text-gray-900 text-2xl font-bold tracking-tight">{value}</span>
        </div>
        {icon && (
          <div className="w-9 h-9 rounded-lg icon-bg-theme flex items-center justify-center flex-shrink-0">
            {getIconComponent(icon)}
          </div>
        )}
      </div>

      <div className="mt-auto pt-2 border-t border-gray-50 flex items-center justify-between">
        <span className="text-gray-500 text-xs font-medium bg-gray-50 px-2 py-0.5 rounded-md truncate max-w-[160px]">
          {change}
        </span>
         {showArrow && isClickable && (
           <img src={ICONS.ARROW_RIGHT} alt='arrow-right '/>
          )}
      </div>
    </div>
  );
};

export default StatsCard;